exports = module.exports = require("../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@-webkit-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-moz-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@-ms-keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}@keyframes sk-fade-in{0%{opacity:0}50%{opacity:0}to{opacity:1}}.sk-fade-in{-webkit-animation:sk-fade-in 2s;-moz-animation:sk-fade-in 2s;-o-animation:sk-fade-in 2s;-ms-animation:sk-fade-in 2s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-spinkit/css/fade-in.css
// module id = 187
// module chunks = 0